import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Upload, UploadService } from '../../core/services/upload.service';

/**
 * Componente para seleccionar un archivoo
 */
@Component({
    selector: 'app-file',
    template: `
      <div [formGroup]="form">
        <div class="drop-container dropzone" dropZone
          (dropped)="field.onUpload($event)" *ngIf="!field.disabled" >
          <p class="m-0 text-center p-2">
            Selecciona la imagen del comprobante de pago
            <br>
            <label class="upload-button">
              <input type="file" multiple="false"
              [disabled]="field.disabled"
              [accept]="field.accept" (change)="onUpload($event)"
              > Subir imagen
            </label>
          </p>
        </div>
        <div *ngIf="field.value" class="text-center">
        <a mat-icon-button class="mat-icon-button" href="{{field.value}}" target="_blank">
        <img class="img-fluid" [src]="field.value" alt="" width="40px"></a>
        </div>
        <input type="text"
              [formControlName]="field?.name" hidden="true"
              >
        <div *ngIf="file">
          <div class="card">
            <p>Archivo seleccionado</p>
            <strong>{{file}}</strong>
          </div>
        </div>
      </div>
    `,
    styles: [
        `
          .drop-container {
            background: #fff;
            border-radius: 6px;
            height: 150px;
            width: 100%;
            box-shadow: 1px 2px 20px hsla(0,0%,4%,.1);
            display: flex;
            align-items: center;
            justify-content: center;
            border: 2px dashed #c0c4c7;
          }
          p {
            font-size: 16px;
            font-weight: 400;
            color: #c0c4c7;
          }
          .upload-button {
            display: inline-block;
            border: none;
            outline: none;
            cursor: pointer;
            color: #5754a3;
          }
          .upload-button input {
            display: none;
          }
          .dropzone {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            border-radius: 5px;
            background: white;
            margin: 10px 0;
          }
          .dropzone.hovering {
              border: 2px solid #f16624;
              color: #dadada !important;
          }
          progress::-webkit-progress-value {
            transition: width 0.1s ease;
          }
          `
    ],
    standalone: false
})
export class FileComponent {
  /**
   * Campo del formulario
   */
  @Input() field: any;
  /**
   * Formulario
   */
  @Input() form!: UntypedFormGroup;
  /**
   * Indica si ya fue seleccionado el archivo
   */
  @Output() fileSelected: EventEmitter<File>;
  /**
   * Archivo seleccionado
   */
  file!: string;
  /**
   * Indica si es valido
   */
  get isValid(): any {
    return this.form.controls[this.field.name].valid;
  }
  /**
   * Indica si esta sucio
   */
  get isDirty(): any {
    return this.form.controls[this.field.name].dirty;
  }

  /**
   * Constructor
   *
   * @param uploadService servicio para subir archivos
   */
  constructor(
    private uploadService: UploadService
  ) {
    this.fileSelected = new EventEmitter();
  }

  /**
   * Carga un archivo en el storage
   *
   * @param file archivo seleccionado
   */
  onUpload(file: any): void {
    this.file = file.target.files[0].name;
    const fileSend = new Upload(file.target.files[0]);
    if (this.field.data.type && this.field.data.type === 'documento') {
      this.uploadService.uploadDocument(fileSend, this.field.data)
        .then((r) => {
          this.form.controls[this.field.name].setValue(r);
          this.field.value = r;
          this.fileSelected.emit(r);
        });
    } else {
      this.uploadService.uploadFile(fileSend, this.field.data)
        .then((r) => {
          this.form.controls[this.field.name].setValue(r);
          this.field.value = r;
          this.fileSelected.emit(r);
        });
    }
  }
}
